import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

/**
 * Returns the default home path for a given role.
 */
export const getDefaultPath = (role) => {
    switch (role) {
        case 'Associate':
        case 'Associate_Team_Lead':
            return '/employee';
        case 'CEO':
        case 'GM_Operations':
        case 'BM_Operations':
        case 'Senior_Team_Lead':
        case 'Team_Lead':
        default:
            return '/';
    }
};

/**
 * ProtectedRoute — wraps routes that require specific roles.
 */
export default function ProtectedRoute({ allowedRoles, activeUser }) {
    const role = activeUser?.role;

    if (!role) {
        return <Navigate to={getDefaultPath(role)} replace />;
    }

    const normalizedAllowed = allowedRoles.flatMap(r => {
        if (r === 'GM_Operations' || r === 'BM_Operations') return ['GM_Operations', 'BM_Operations'];
        if (r === 'Associate_Team_Lead' || r === 'Associate') return ['Associate_Team_Lead', 'Associate'];
        if (r === 'Team_Lead' || r === 'Senior_Team_Lead') return ['Team_Lead', 'Senior_Team_Lead'];
        return [r];
    });

    if (!normalizedAllowed.includes(role)) {
        return <Navigate to={getDefaultPath(role)} replace />;
    }

    return <Outlet />;
}

